import React from 'react'

function SocietyPoints() {
    return (
        <div>
            Society Points
        </div>
    )
}

export default SocietyPoints
